import {createFeatureSelector, createSelector} from '@ngrx/store';
import {PositionState} from './position.state';
import {positionsFeatureKey} from './position.reducer';

const positionSelector = createFeatureSelector<PositionState>(positionsFeatureKey);

export const selectPosition = createSelector(
  positionSelector,
  state => state.position
);

export const selectTlPositions = createSelector(
  positionSelector,
  state => state.tlPositions
);

export const selectTpPositions = createSelector(
  positionSelector,
  state => state.tpPositions
);

export const selectBmPositions = createSelector(
  positionSelector,
  state => state.bmPositions
);

export const selectPmDocuments = createSelector(
  positionSelector,
  state => state.pmDocuments
);

export const selectTpLoading = createSelector(positionSelector, state => state.isTpLoading);
export const selectTlLoading = createSelector(positionSelector, state => state.isTlLoading);
export const selectBmLoading = createSelector(positionSelector, state => state.isBmLoading);
